export default {
  setOrders(_state: any, value: object[]) {
    _state.orders = value
  },

  setDeliveryAddresses(_state: any, value: object[]) {
    _state.deliveryAddresses = value
  },

  setFrameColoring(_state: any, value: object) {
    _state.frameColoring = value
  },

  setCreateGlassesDetailsField(_state: any, { field, value }: { field: string, value: any }) {
    _state.createGlassesDetails[field] = value
  },

  setCreateGlassesDetails(_state: any, value: object) {
    _state.createGlassesDetails = value
  },

  setDeliveryCompanies(_state: any, value: object[]) {
    _state.deliveryCompanies = value
  },

  addOrderToCart({orders}: any, value: string) {
    if (!orders.includes(value)) {
      orders.push(value)
    }
  },
  deleteOrderToCart(_state: any, value: string) {
    delete _state.orders[value]
  },
  setCurrentOrder(_state: any, value: string) {
    _state.currentOrder = value
  },
  setItemsCountInCart(_state: any, { orders, orders_rx, orderitems, orderitems_rx }: any) {
    _state.warehouseOrdersCount = orders || 0
    _state.rxOrdersCount = orders_rx || 0
    _state.warehouseItemsCount = orderitems || 0
    _state.rxItemsCount = orderitems_rx || 0
  },
  setCurrentTab(_state: any, tab: string) {
    _state.currentTab = tab
  }
}
